import { generateClassName } from '@klv/shared/utils/functions';

import { backgroundToTextColor } from '@klv/shared/styles/utils';

import * as styles from './styles/badge.module.css';

import type { IBadge } from './types';

const Badge = ({
  children,
  className = '',
  color = 'charcoal',
  text,
  variant,
  ...props
}: IBadge) => {

  const colorInKebab = color.replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
  return (
  <span
    className={generateClassName([className, styles.badge,  variant === 'medium' ? styles.mediumBadge : ''])}
    style={{
      '--badge-background-color': (color === 'poppy') ? 'var(--color-poppy-shade)' : `var(--color-${colorInKebab})`,
      '--badge-text-color': (color === 'poppy' || color === 'poppyShade') ? 'var(--color-white)' : backgroundToTextColor[color],
    } as React.CSSProperties}
    {...props}
  >
    {children ?? text}
  </span>
  );
};

export default Badge;
